export default __webpack_public_path__ + "static/media/640_dummy2016-psychotherapie01-de.3898d046.png";